import { useNavigate, useParams } from 'react-router';
import KitoBuddy from '../../components/Buddy';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import styles from './styles.module.css';
import './skills.css';
import { useEffect, useMemo, useState } from 'react';
import KitoButton from '../../components/Inputs/KitoButton';
import closeButtonPic from '../../assets/designSystem/icons/close.svg';
import skills from './skills';
import Congratulations from './Congratulations';
import { useTranslation } from 'react-i18next';
import BaseLayout from '../../commons/BaseLayout';

const VERSION_STORAGE_KEY = '@kitoApp/version';

function generateHTML(arr, fragment, t, list) {
  arr.forEach((element) => {
    const tag = element.tag || (list ? 'li' : 'p');
    const newElement = document.createElement(tag);
    const cls = `skillStaticPage__content__${tag}__${element.listType || 'bullet'}`;

    if (styles[cls]) newElement.classList.add(styles[cls]);

    if (element.tag === 'ul') generateHTML(element.texts, newElement, t, true);
    else if (element.texts) generateHTML(element.texts, newElement, t);
    else newElement.textContent = t(element.text || element);

    fragment.appendChild(newElement);
  });
}

export default function Skill() {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentSkill = skills[params.skill];
  const [, setActiveVersion] = useState(
    () => globalThis.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult'
  );

  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const currentPage = useMemo(() => currentSkill[currentPageIndex], [currentPageIndex]);

  useEffect(() => {
    if (currentPageIndex >= currentSkill.length) return;
    const content = document.querySelector('#skill-static-page__content');
    const existingTitle = document.querySelector(`.${styles['skillStaticPage__content__inner__h3']}`);
    if (existingTitle) existingTitle.remove();
    if (currentPage.innerTitle) {
      const title = document.createElement('h3');
      title.classList.add(styles['skillStaticPage__content__inner__h3']);
      title.textContent = t(currentPage.innerTitle);
      content.before(title);
    }

    content.innerHTML = '';
    const fragment = document.createDocumentFragment();
    generateHTML(currentPage.texts, fragment, t);
    content.appendChild(fragment);
  }, [currentPageIndex]);

  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar fitHeight>
      <div className={styles.skillStaticPage}>
        <div className={styles.skillStaticPage__header}>
          <ProgressBar controls onClose={() => navigate('/new-skills')} showData={false} width={100} percent={currentPageIndex / (currentSkill.length - 1) * 100 || 0} />
        </div>
        {currentPageIndex < currentSkill.length ? (
          <>
            <div className={styles.skillStaticPage__scroll}>
              <KitoBuddy image={currentPage.mascot}>{t(currentPage.balloon)}</KitoBuddy>
              <div
                className={styles.skillStaticPage__content}
                data-type={currentPage.type || 'default'}
                data-variant={currentPage.variant || 'default'}
                data-border={currentPage.border || 'thin'}
              >
                <div id="skill-static-page__content" className={`${styles.skillStaticPage__content__internalRadius} skillStaticPage__content__internalRadius`} />
              </div>
            </div>
            <div className={styles.skillStaticPage__buttons}>
              <KitoButton
                hierarchy="secondary"
                onClick={() =>
                  currentPageIndex === 0 ? navigate('/new-skills') : setCurrentPageIndex((prev) => prev - 1)
                }
              >
                Back
              </KitoButton>
              <KitoButton onClick={() => setCurrentPageIndex((prev) => prev + 1)}>Next</KitoButton>
            </div>
          </>
        ) : (
          <Congratulations />
        )}
      </div>
    </BaseLayout>
  );
}
